import React, { Component } from 'react';

// Components
import DataService from 'js/modules/dataservice';
import storage from 'js/modules/persist';

const chanData =  {
  Bookingstep: window._app.page.step, /* #obedata.menu_data.CurrentStep# cf -> java */
  Brand: window._app.brandOptions.longName,
  Currentpagetitle: document.title,
  FlighError: false, /* #obedata.air_data.air_warning# this has to be checked with edwin for this error, */
  Gateway: '', /* '#obedata.room_data.departure_gateway#' has to read summary, component? */
  OBEError: '',
  Ordertotal: (0 + 0), /* #obedata.room_data.room_total + obedata.air_data.air_total#, has to come from backend */
  requoteflag: false, /* <cfif requoteflag eq "true,true">true<cfelse>#requoteflag#</cfif>, */
  Resort: '', /* '#obedata.room_data.resort#', summary, component? */
  RoomCategory: '', /* '#obedata.room_data.room_category#', summary, component? */
  SalesValue: (0 + 0), /* #obedata.room_data.room_total + obedata.air_data.air_total#, has to come from backend */
  TravelMonth: '', /* '#obedata.room_data.check_in_date#', byron will confirm */
  lastName: '' /* '#obedata.room_data.LastName#' summary, component? */
};

function calcBookingTotal(roomTotal, flightsTotal) {
  const room = roomTotal || 0;
  const flight = flightsTotal || 0;

  return room + flight;
}

class Moxie extends Component {
  componentDidMount() {
    this.getSummary();
    // this.concReady();
    this.agentJoinedSession();
  }

  getSummary = async() => {
    const summaryResponse = await DataService.readSummary();
    const { code, content } = summaryResponse;
    const { bookingTotal, flightsTotal, vacationData, roomData, guestsData, moxieConversion } = content;
    const { Bookingstep } = chanData;

    // response resolved then call conciergeReady
    if (code === 1) {
      chanData.Ordertotal = calcBookingTotal(bookingTotal, flightsTotal);
      chanData.SalesValue = calcBookingTotal(bookingTotal, flightsTotal);

      // campaign params
      if (moxieConversion) {
        if (moxieConversion.esv_medium) {
          chanData.esv_medium = moxieConversion.esv_medium;
        }
        if (moxieConversion.esv_term) {
          chanData.esv_term = moxieConversion.esv_term;
        }
        if (moxieConversion.gclid) {
          chanData.gclid = moxieConversion.gclid;
        }
        if (moxieConversion.PID) {
          chanData.PID = moxieConversion.PID;
        }
        if (moxieConversion.spJobId) {
          chanData.spJobId = moxieConversion.spJobId;
        }
        if (moxieConversion.spMailingId) {
          chanData.spMailingId = moxieConversion.spMailingId;
        }
        if (moxieConversion.spReportId) {
          chanData.spReportId = moxieConversion.spReportId;
        }
        if (moxieConversion.spUserId) {
          chanData.spUserId = moxieConversion.spUserId;
        }
        if (moxieConversion.utm_campaign) {
          chanData.utm_campaign = moxieConversion.utm_campaign;
        }
        if (moxieConversion.utm_content) {
          chanData.utm_content = moxieConversion.utm_content;
        }
        if (moxieConversion.utm_source) {
          chanData.utm_source = moxieConversion.utm_source;
        }
        if (moxieConversion.utm_term) {
          chanData.utm_term = moxieConversion.utm_term;
        }
        if (moxieConversion.Wtmc_id) {
          chanData.Wtmc_id = moxieConversion.Wtmc_id;
        }
      }

      if (vacationData) {
        const { checkInDate, airIncluded, departureFrom, rstCode } = vacationData;

        chanData.TravelMonth = checkInDate;

        if (airIncluded && departureFrom) {
          chanData.Gateway = departureFrom.toUpperCase();
          chanData.Resort =  rstCode.toUpperCase();
        }
      }

      if (roomData) {
        const { roomCode, rstCode } = roomData;

        chanData.RoomCategory = roomCode.toUpperCase();
        chanData.Resort =  rstCode.toUpperCase();
      }

      if (guestsData) {
        const { lastName } = guestsData;

        chanData.lastName = lastName;
      }

      console.log('Bookingstep', Bookingstep);
      if (Bookingstep === 5) {
        this.updateSession(content);
      }

      if (Bookingstep === 6) {
        this.transactionComplete(content);
        this.salesConversion(content);
      }

      this.concReady();
    }
  }

  concReady = () => {
    try {
      conciergeReady.then(() => {
        this.agentJoinedSession();
        this.channelsData();
      });
    } catch (err) {
      console.warn('concReady at MoxieJS catched an error.', err);
    }
  }

  agentJoinedSession = () => {
    console.log('agentJoinedSession');
    try {
      window.addEventListener('GoMoxie:widget:chat:agentJoinedSession', (e) => {
        console.log('gonna create a cookie for moxie chat');
        const agentSessionID = e.detail.sessionId;
        const d = new Date();

        d.setTime(d.getTime() + (12 * 60 * 60 * 1000));

        document.cookie = `agentJoinedSession=${ agentSessionID };domain=.${ window._app.brandOptions.longName }.com;path=/;expires=${ d.toUTCString() }`;
        document.cookie = `MoxieSessionID=${ agentSessionID };domain=.${ window._app.brandOptions.longName }.com;path=/;expires=${ d.toUTCString() }`;
      });
    } catch (err) {
      console.warn('agentJoinedSession at MoxieJS catched an error.', err);
    }
  }

  channelsData = () => {
    if (typeof window.GoMoxie !== 'undefined') {
      try {
        window.GoMoxie.conciergeV2.channelsData(chanData);
      } catch (err) {
        console.warn('agentJoinedSession at MoxieJS catched an error.', err);
      }
    }
  }

  updateSession = (vacationData) => {
    const myTransactionTotal = vacationData.bookingTotal;
    const myCurrentCartTotal = vacationData.bookingTotal;
    const myCurrentCartItems = [
      {
        name: chanData.Resort,
        value: vacationData.bookingTotal,
        quantity: 1,
        description: vacationData.roomData.roomName,
        uom: 'each',
        resortCode: chanData.Resort
      }
    ];

    try {
      window.GoMoxie.conciergeV2.updateSession({
        transactionTotal: myTransactionTotal,
        currentCartValue: myCurrentCartTotal,
        currentCartItems: myCurrentCartItems
      });
    } catch (err) {
      console.warn('updateSession at MoxieJS catched an error.', err);
    }
  }

  transactionComplete = (vacationData) => {
    const myTransactionTotal = vacationData.bookingTotal; // Total transaction value.
    const myCurrentCartTotal = vacationData.bookingTotal; // Current cart value, updated throughout the journey

    // User friendly name for the item
    const myCurrentCartItems = [{
      name: chanData.Resort,
      skuOrId: vacationData.webConfirmationNumber, // An ID or SKU recognizable for the company
      value: vacationData.bookingTotal, // The cost of an individual item
      quantity: 1, // How many of this item
      description: vacationData.roomData.roomName, // A friendly description for the item
      uom: 'each', // The 'Unit of Measurement' for the item
      resortCode: chanData.Resort,
      confirmationNo: vacationData.webConfirmationNumber
    }];

    // GoMoxie.concierge - transactionComplete
    try {
      conciergeReady.then(() => {
        window.GoMoxie.conciergeV2.transactionComplete({
          transactionTotal: myTransactionTotal,
          currentCartValue: myCurrentCartTotal,
          currentCartItems: myCurrentCartItems,
          vendorTxnId: vacationData.webConfirmationNumber
        });
      });
    } catch (err) {
      console.warn('transactionComplete at MoxieJS catched an error.', err);
    }
  }

  salesConversion = (vacationData) => {
    if (storage.get('salesConversion').code === 0) {
      let cimIframe = '';
      const serverAction = '/NetAgent/salesconversion.aspx';

      // *** Please put CIM Server information here ***
      const serverName = 'unique-vacations.ehosts.net';
      const serverPort = '443';
      const serverProtocol = 'https://';
      const mxAgentSessionID = this.getCookie('agentJoinedSession');

      // *** Please put CIM Server information here ***
      let serverUrl = serverProtocol + serverName + ':' + serverPort + serverAction;

      try {

        serverUrl += `?SalesConversion=**USD**${ vacationData.bookingTotal }**${ vacationData.webConfirmationNumber },OBE**${ chanData.Resort }**&SessionID=${ mxAgentSessionID }`;

        cimIframe = document.createElement('iframe');
        cimIframe.setAttribute('id', 'cim_sales_frame');
        cimIframe.setAttribute('name', 'cim_sales_frame');
        cimIframe.setAttribute('src', serverUrl);
        cimIframe.style.display = 'none';
        document.body.appendChild(cimIframe);
        console.log('Moxie Server Url', serverUrl);

        storage.save('salesConversion', true);
      } catch (err) {
        console.warn('salesConversion at MoxieJS catched an error.', err);
      }
    }
  }

  getCookie = (cname) => {
    const name = cname + '=';
    const ca = document.cookie.split(';');

    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  render() {
    return(
      <div>{ '' }</div>
    );
  }
}

export default Moxie;



// WEBPACK FOOTER //
// ./js/components/global/Moxie.js